module.exports = __webpack_public_path__ + "img/pmg1.804819d3.png";